<template>
  <div class="page-content-pc">
    <div class="banner gsap-fade-down">
      <div class="introduce">
        <div class="introduce_title">
          接入AI大模型的智能客服系统
        </div>
        <div class="introduce_desc">
          通全平台、懂产品 会营销多维赋能电商
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 板块1 -->
      <div class="title-box">
        <div class="title_text">
          驱动电商服务的智能跃迁
        </div>
        <div class="title_line">
          四维升级，重构电商服务竞争力
        </div>
      </div>
      <div class="section1">
        <div class="section1-left">
          <div :class="['switch-btn', { active: currentIndex === 0 }]" @click="currentIndex = 0">
            <div class="switch-btn-title">人力释放革命</div>
            <div class="switch-btn-desc">释放团队高价值潜能，专注情感化服务</div>
          </div>
          <div :class="['switch-btn', { active: currentIndex === 1 }]" @click="currentIndex = 1">
            <div class="switch-btn-title">零等待体验</div>
            <div class="switch-btn-desc">秒级终结咨询排队，转化率提升30%+</div>
          </div>
        </div>
        <div class="section1-right">
          <div class="switch-img-box" v-if="currentIndex === 0">
            <img :src="switchImg1" alt="图1" class="switch-img" />
            <img :src="switchImg1msg1" alt="图1msg1" class="msg-img switch-img1-msg1 gsap-fade-msg"
              ref="switchImg1msg1" />
            <img :src="switchImg1msg2" alt="图1msg2" class="msg-img switch-img1-msg2 gsap-fade-msg"
              ref="switchImg1msg2" />
            <img :src="switchImg1msg3" alt="图1msg3" class="msg-img switch-img1-msg3 gsap-fade-msg"
              ref="switchImg1msg3" />
          </div>
          <div class="switch-img-box" v-else>
            <img :src="switchImg2" alt="图2" class="switch-img" />
            <img :src="switchImg2msg1" alt="图2msg1" class="msg-img switch-img2-msg1 gsap-fade-msg"
              ref="switchImg2msg1" />
            <img :src="switchImg2msg2" alt="图2msg2" class="msg-img switch-img2-msg2 gsap-fade-msg"
              ref="switchImg2msg2" />
            <img :src="switchImg2msg3" alt="图2msg3" class="msg-img switch-img2-msg3 gsap-fade-msg"
              ref="switchImg2msg3" />
            <img :src="switchImg2msg4" alt="图2msg4" class="msg-img switch-img2-msg4 gsap-fade-msg"
              ref="switchImg2msg4" />
          </div>
        </div>
      </div>
      <!-- 板块1结束 -->

      <!-- 板块2 -->
      <div class="title-box">
        <div class="title_text">
          全栈靶向适配，让AI生长于您的业务基因
        </div>
        <div class="title_line">
          全栈原生支持 + 200+深度定制参数，实现从终端覆盖到业务逻辑的精准配置
        </div>
      </div>
      <div class="section2">
        <div v-for="(item, idx) in section2List" :key="item.title"
          :class="['section2-card', { 'is-hover': hoverIndex === idx }]" @mouseenter="hoverIndex = idx"
          @mouseleave="hoverIndex = null" :style="hoverIndex === idx ? { backgroundImage: `url(${hoverBg})` } : {}">
          <div class="section2-card-title">{{ item.title }}</div>
          <div class="section2-card-subtitle">{{ item.subtitle }}</div>
          <div class="section2-card-desc" v-for="desc in item.desc" :key="desc">{{ desc }}</div>
        </div>
      </div>
      <div class="platforms">
        <div class="platforms-inner">
          <div class="platforms-glow"></div>
          <div v-for="item in platforms" :key="item.name" class="platform-item">
            <img :src="item.icon" :alt="item.name" class="platform-icon" />
            <span class="platform-name">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <!-- 板块2结束 -->

      <!-- 板块3 -->
      <div class="title-box">
        <div class="title_text">
          选择智寰的理由
        </div>
        <div class="title_line">
          千亿级大模型为底座 × 电商垂直场景深度驯化 ×上千家企业实战验证，打造更懂生意增长的AI技术引擎
        </div>
      </div>
      <div class="reasons">
        <!-- 第一行 -->
        <div class="reason-row">
          <div class="reason-img-wrap reason-img1-wrap"><img :src="reasonImg1" alt="千亿级大模型"
              class="reason-img  gsap-fade-left" /></div>
          <div class="reason-content reason-content1">
            <div class="reason-title">千亿级大模型加持，更智能</div>
            <div class="reason-subtitle reason-subtitle1">架构本质</div>
            <div class="reason-desc reason-desc1">基于混合专家系统（MoE）的稀疏激活架构，在1.2万亿token电商语料上预训练，包含1120亿有效参数（经知识蒸馏压缩）。</div>
            <div class="reason-subtitle reason-subtitle2">领域强化</div>
            <div class="reason-desc reason-desc2">商品认知引擎：精准解析百万级SKU属性（如服装的“桑蚕丝含量”“立体剪裁工艺”）</div>
            <div class="reason-desc reason-desc3">
              跨会话意图追踪：用户30天内咨询记录深度关联分析</div>
            <div class="reason-desc reason-desc3">效能保障：经2025年618实战验证，单GPU节点可承载8.5万QPS并发问答，响应延迟稳定在380ms±20ms（含安全加密开销）
            </div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="reason-row row-reverse">
          <div class="reason-img-wrap reason-img2-wrap gsap-fade-right"><img :src="reasonImg2" alt="零摩擦落地保障"
              class="reason-img" /></div>
          <div class="reason-content reason-content2">
            <div class="reason-title">零摩擦落地保障，更简单</div>
            <div class="reason-subtitle reason-subtitle1">极速接入</div>
            <div class="reason-desc reason-desc1">基于预封装电商接口，通过可视化路由配置器，最快3分钟即可完成客服系统对接与知识库初始化，旧系统改造全程业务0中断。</div>
            <div class="reason-subtitle reason-subtitle2">智能见效引擎</div>
            <div class="reason-desc reason-desc2">
              部署后自动启动「7天数据驯化」——前3天学习咨询日志优化应答策略，后4天开启A/B测试对比人工客服指标，保障咨询转化率提升≥32%（签约企业实测均值）</div>
          </div>
        </div>
        <!-- 第三行 -->
        <div class="reason-row">
          <div class="reason-img-wrap reason-img3-wrap  gsap-fade-left"><img :src="reasonImg3" alt="全域生态无缝融合"
              class="reason-img" />
          </div>
          <div class="reason-content reason-content3">
            <div class="reason-title">全域生态无缝融合，更快捷</div>
            <div class="reason-subtitle reason-subtitle1">多平台</div>
            <div class="reason-desc reason-desc1">深度适配淘宝/京东/抖音/快手/微信生态，同步扩展Amazon/Shopify/TikTok Shop，让智能客服无时差覆盖每个商机触点
            </div>
            <div class="reason-subtitle reason-subtitle2">情感计算中枢</div>
            <div class="reason-desc reason-desc2">
              结合订单时效/用户活跃时段/历史付款习惯（如支付宝偏好），在黄金3小时内触发个性化催付——未支付高客单用户推送“专属库存保留”消息，犹豫期消费者自动发放限时运费险。情感化交互：实时识别焦虑→共情（“完全理解您着急的心情”）→
              解决（优先发货+进度直播），差评拦截成功率达92%。</div>
          </div>
        </div>
      </div>
      <!-- 板块3结束 -->
    </div>
  </div>
</template>

<script>
import switchImg1 from '../../assets/img/home/pc/switch_img1.png'
import switchImg2 from '../../assets/img/home/pc/switch_img2.png'
import switchImg1msg1 from '../../assets/img/home/pc/switch_img1_msg1.png'
import switchImg1msg2 from '../../assets/img/home/pc/switch_img1_msg2.png'
import switchImg1msg3 from '../../assets/img/home/pc/switch_img1_msg3.png'
import switchImg2msg1 from '../../assets/img/home/pc/switch_img2_msg1.png'
import switchImg2msg2 from '../../assets/img/home/pc/switch_img2_msg2.png'
import switchImg2msg3 from '../../assets/img/home/pc/switch_img2_msg3.png'
import switchImg2msg4 from '../../assets/img/home/pc/switch_img2_msg4.png'


import hoverBg from '../../assets/img/home/pc/hover_bg.png'
import webIcon from '../../assets/img/home/pc/web_icon.png'
import iosIcon from '../../assets/img/home/pc/ios_icon.png'
import androidIcon from '../../assets/img/home/pc/android_icon.png'
import windowsIcon from '../../assets/img/home/pc/windows_icon.png'
import reasonImg1 from '../../assets/img/home/pc/reason_img1.png'
import reasonImg2 from '../../assets/img/home/pc/reason_img2.png'
import reasonImg3 from '../../assets/img/home/pc/reason_img3.png'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'HomePC',
  data() {
    return {
      currentIndex: 0,
      switchImg1,
      switchImg2,
      switchImg1msg1,
      switchImg1msg2,
      switchImg1msg3,
      switchImg2msg1,
      switchImg2msg2,
      switchImg2msg3,
      switchImg2msg4,
      hoverBg,
      webIcon,
      iosIcon,
      androidIcon,
      windowsIcon,
      reasonImg1,
      reasonImg2,
      reasonImg3,

      hoverIndex: null,
      section2List: [
        {
          title: '原生级',
          subtitle: '性能优化',
          desc: ['各平台CPU占用率<15%', '万级并发下响应延迟<300ms']
        },
        {
          title: '军工级',
          subtitle: '安全部署',
          desc: ['敏感数据本地沙盒处理', '0云端存储']
        },
        {
          title: '模块化',
          subtitle: '无缝集成',
          desc: ['SDK/API/插件三种接入模式', '最快三分钟部署']
        },
        {
          title: '基因级',
          subtitle: '业务定制',
          desc: ['支持200+定制参数配置', '从界面到业务流程全栈可定制']
        }
      ],
      platforms: [
        { name: 'WEB', icon: webIcon },
        { name: 'IOS', icon: iosIcon },
        { name: 'Android', icon: androidIcon },
        { name: 'Windows', icon: windowsIcon }
      ]
    }
  },
  watch: {
    currentIndex() {
      this.animateSwitchImgs();
    }
  },
  mounted() {
    // 检查是否为预渲染环境
    const isPrerendering = typeof window !== 'undefined' && window.__PRERENDER_INJECTED;

    if (gsap && gsap.utils && gsap.fromTo && !isPrerendering) {
      // 向上淡入
      gsap.utils.toArray('.gsap-fade-up').forEach(el => {
        gsap.fromTo(el,
          { y: 60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // 从左到中间
      gsap.utils.toArray('.gsap-fade-left').forEach(el => {
        gsap.fromTo(el,
          { x: -100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // 从右到中间
      gsap.utils.toArray('.gsap-fade-right').forEach(el => {
        gsap.fromTo(el,
          { x: 100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // 从上往下淡入（title-box）
      gsap.utils.toArray('.gsap-fade-down').forEach(el => {
        gsap.fromTo(el,
          { y: -60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // title_text动画
      gsap.utils.toArray('.gsap-fade-down-title').forEach(el => {
        gsap.fromTo(el,
          { y: -60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // title_line动画，延迟0.2s
      gsap.utils.toArray('.gsap-fade-down-line').forEach(el => {
        gsap.fromTo(el,
          { y: -60, opacity: 0 },
          {
            y: 0,
            opacity: 1,
            duration: 1,
            delay: 0.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 80%",
              end: "top 30%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
      // 气泡图片滚动动画
      const msgImgAnims = [
        // currentIndex 0
        { selector: '.switch-img1-msg1', from: { opacity: 0, x: -60 }, to: { opacity: 1, x: 0, delay: 0 } },
        { selector: '.switch-img1-msg2', from: { opacity: 0, x: 60 }, to: { opacity: 1, x: 0, delay: 0.2 } },
        { selector: '.switch-img1-msg3', from: { opacity: 0, x: 0 }, to: { opacity: 1, x: 0, delay: 0.4 } },
        // currentIndex 1
        { selector: '.switch-img2-msg1', from: { opacity: 0, y: -60 }, to: { opacity: 1, y: 0, delay: 0 } },
        { selector: '.switch-img2-msg2', from: { opacity: 0, x: 60 }, to: { opacity: 1, x: 0, delay: 0.2 } },
        { selector: '.switch-img2-msg3', from: { opacity: 0, x: -60 }, to: { opacity: 1, x: 0, delay: 0.4 } },
        { selector: '.switch-img2-msg4', from: { opacity: 0, scale: 0.7 }, to: { opacity: 1, scale: 1, delay: 0.6 } },
      ];
      msgImgAnims.forEach(anim => {
        // 检查元素是否存在再执行动画
        const element = document.querySelector(anim.selector);
        if (element) {
          console.log('Element found:', anim.selector);
          gsap.fromTo(anim.selector,
            anim.from,
            {
              ...anim.to,
              duration: 0.5,
              ease: "power2.out",
              scrollTrigger: {
                trigger: anim.selector,
                start: "top 80%",
                end: "top 30%",
                toggleActions: "restart none none reverse"
              }
            }
          );
        } else {
          console.log('Element not found:', anim.selector);
        }
      });
      // platforms光效动画
      this.$nextTick(() => {
        this.$gsap.set('.platforms-glow', { x: -120, opacity: 0.7 });
        this.$gsap.fromTo('.platforms-glow',
          { x: -120, opacity: 0.7 },
          {
            x: 1400,
            opacity: 0.7,
            duration: 1.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: '.platforms',
              start: "top 80%",
              toggleActions: "restart none none reverse"
            }
          }
        );
      });
    }
    this.animateSwitchImgs();
  },
  methods: {
    animateSwitchImgs() {
      // 检查是否为预渲染环境
      const isPrerendering = typeof window !== 'undefined' && window.__PRERENDER_INJECTED;
      if (isPrerendering || !this.$gsap) return;

      this.$nextTick(() => {
        if (this.currentIndex === 0) {
          // switchImg1msg1: 从左往右
          const img1 = this.$refs.switchImg1msg1;
          if (img1) {
            this.$gsap.set(img1, { opacity: 0, x: -60 });
            this.$gsap.to(img1, { opacity: 1, x: 0, duration: 0.5, delay: 0 });
          }
          // switchImg1msg2: 从右往左
          const img2 = this.$refs.switchImg1msg2;
          if (img2) {
            this.$gsap.set(img2, { opacity: 0, x: 60 });
            this.$gsap.to(img2, { opacity: 1, x: 0, duration: 0.5, delay: 0.2 });
          }
          // switchImg1msg3: 原地淡入
          const img3 = this.$refs.switchImg1msg3;
          if (img3) {
            this.$gsap.set(img3, { opacity: 0, x: 0 });
            this.$gsap.to(img3, { opacity: 1, x: 0, duration: 0.5, delay: 0.4 });
          }
        } else if (this.currentIndex === 1) {
          // switchImg2msg1: 从上往下
          const img1 = this.$refs.switchImg2msg1;
          if (img1) {
            this.$gsap.set(img1, { opacity: 0, y: -60 });
            this.$gsap.to(img1, { opacity: 1, y: 0, duration: 0.5, delay: 0 });
          }
          // switchImg2msg2: 从右往左
          const img2 = this.$refs.switchImg2msg2;
          if (img2) {
            this.$gsap.set(img2, { opacity: 0, x: 60 });
            this.$gsap.to(img2, { opacity: 1, x: 0, duration: 0.5, delay: 0.2 });
          }
          // switchImg2msg3: 从左往右
          const img3 = this.$refs.switchImg2msg3;
          if (img3) {
            this.$gsap.set(img3, { opacity: 0, x: -60 });
            this.$gsap.to(img3, { opacity: 1, x: 0, duration: 0.5, delay: 0.4 });
          }
          // switchImg2msg4: 原地放大淡入
          const img4 = this.$refs.switchImg2msg4;
          if (img4) {
            this.$gsap.set(img4, { opacity: 0, scale: 0.7 });
            this.$gsap.to(img4, { opacity: 1, scale: 1, duration: 0.5, delay: 0.6 });
          }
        }
      });
    }
  }
}
</script>
<style scoped lang="scss">
.page-content-pc {
  margin-top: 64px;
  width: 100%;
  // overflow-x: hidden;
  min-width: max-content;

  .banner {
    height: 520px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    background: url('../../assets/img/home/pc/banner.png') no-repeat center center;
    background-size: cover;
    margin-bottom: 68px;

    .introduce {
      width: 1280px;
      margin: 0 auto;

      .introduce_title {
        font-weight: bold;
        font-size: 42px;
        color: #1D203D;
      }

      .introduce_desc {
        width: 306px;
        font-weight: 500;
        font-size: 34px;
        color: #1D203D;
        margin-top: 54px;
      }
    }
  }

  .content {
    width: 1280px;
    margin: 0 auto;
    height: 100%;

    .title-box {
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      margin-bottom: 32px;

      .title_text {
        width: 100%;
        display: inline-block;
        font-weight: 800;
        font-size: 40px;
        line-height: 56px;
        font-style: normal;
        text-transform: none;
        background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        color: transparent;
        margin-bottom: 14px;
      }

      .title_line {
        width: 100%;
        font-weight: 500;
        font-size: 24px;
        color: #333333;
        line-height: 34px;
        font-style: normal;
        text-transform: none;
      }
    }

    .section1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 77px;

      .section1-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 48px 0;

        .switch-btn {
          color: #333;
          background: #EEF5FF;
          border-radius: 12px;
          padding: 25px 30px;
          transition: background 0.2s, color 0.2s;
          cursor: pointer;
          user-select: none;

          .switch-btn-title {
            font-weight: 800;
            font-size: 24px;
            margin-bottom: 8px;
          }

          .switch-btn-desc {
            font-weight: 500;
            font-size: 20px;
          }
        }

        .switch-btn.active {
          background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
          box-shadow: 1px 4px 10px 0px rgba(0, 76, 255, 0.36);
          color: #fff;
        }
      }


      .section1-right {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 760px;
        height: 468px;
        user-select: none;

        .switch-img-box {
          position: relative;
          width: 100%;
          height: 100%;

          .switch-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }

          .msg-img {
            position: absolute;
          }

          .switch-img1-msg1 {
            width: 360px;
            height: 50px;
            left: 100px;
            top: 150px;
          }

          .switch-img1-msg2 {
            width: 330px;
            height: 64px;
            left: 268px;
            top: 230px;
          }

          .switch-img1-msg3 {
            width: 276px;
            height: 62px;
            left: 323px;
            top: 314px;
          }

          .switch-img2-msg1 {
            width: 196px;
            height: 88px;
            left: 383px;
            top: 118px;
          }

          .switch-img2-msg2 {
            width: 196px;
            height: 88px;
            left: 397px;
            top: 184px;
          }

          .switch-img2-msg3 {
            width: 193px;
            height: 79px;
            left: 397px;
            top: 250px;
          }

          .switch-img2-msg4 {
            width: 192px;
            height: 120px;
            left: 389px;
            top: 301px;
          }
        }
      }


    }

    .section2 {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      gap: 32px;
      margin-top: 68px;

      .section2-card {
        width: 296px;
        height: 320px;
        background: #EEF5FF;
        border-radius: 4px;
        position: relative;
        transition: background 0.2s, box-shadow 0.2s;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;

        .section2-card-title {
          font-size: 28px;
          font-weight: 800;
          background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
          display: inline-block;
        }

        .section2-card-subtitle {
          font-size: 28px;
          font-weight: 800;
          margin-bottom: 38px;
          color: #222;
        }

        .section2-card-desc {
          font-weight: 500;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 24px;
        }
      }

      .section2-card.is-hover {
        color: #0052d9;
        box-shadow: 0 8px 24px 0 rgba(0, 76, 255, 0.12);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }


    }

    .platforms {
      width: 100%;
      margin: 36px auto 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 68px;

      .platforms-inner {
        width: 100%;
        height: 98px;
        background: linear-gradient(90deg, #00A1FF 0%, #0F3FFF 100%);
        display: flex;
        align-items: center;
        justify-content: space-around;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;

        .platforms-glow {
          position: absolute;
          top: 0;
          left: -120px;
          width: 120px;
          height: 100%;
          background: linear-gradient(120deg, rgba(255, 255, 255, 0.0) 0%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 0.0) 100%);
          pointer-events: none;
          z-index: 2;
          opacity: 0.7;
          filter: blur(2px);
        }

        .platform-item {
          display: flex;
          align-items: center;
          gap: 30px;

          .platform-icon {
            width: 50px;
            height: 50px;
            object-fit: contain;
            box-sizing: border-box;
          }

          .platform-name {
            font-weight: 500;
            font-size: 32px;
            color: #FFFFFF;
            letter-spacing: 1px;
          }
        }


      }


    }

    .reasons {
      display: flex;
      flex-direction: column;
      margin-top: 58px;
      margin-bottom: 78px;

      .reason-row {
        display: flex;
        align-items: center;
        background: #fff;
        border-radius: 8px;
        gap: 36px;
        flex-wrap: wrap;

        .row-reverse {
          flex-direction: row-reverse;
        }

        .reason-img-wrap {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          background: none;
        }

        .reason-img1-wrap {
          width: 677px;
          height: 435px;
        }

        .reason-img2-wrap {
          width: 689px;
          height: 510px;
        }

        .reason-img3-wrap {
          width: 705px;
          height: 480px;
        }

        .reason-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }

        .reason-content {
          flex: 1;
          box-sizing: border-box;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: center;


        }

        .reason-content1 {
          flex: 0.86;
        }

        .reason-content2 {
          flex: 0.9;
          margin-top: -80px;
        }

        .reason-content3 {
          flex: 0.9;
          margin-top: 50px;
        }

        .reason-title {
          font-weight: bold;
          font-size: 32px;
          color: #333333;
          margin-bottom: 24px;
          text-align: left;
        }

        .reason-subtitle {
          width: fit-content;
          padding: 5px 13px;
          border-radius: 2px;
          font-weight: 500;
          font-size: 24px;
          color: #000000;
          margin-bottom: 16px;
          text-align: center;
        }

        .reason-subtitle1 {
          background: #EEF5FF;

        }

        .reason-subtitle2 {
          background: #EEEEFF;
        }

        .reason-desc {
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          text-align: left;
          word-break: break-all;
        }

        .reason-desc1 {
          margin-bottom: 28px;
        }

        .reason-desc2 {
          margin-bottom: 6px;
        }

      }

      .reason-row.row-reverse {
        flex-direction: row-reverse;
        margin-top: 126px;
        margin-bottom: 56px;
      }

    }


  }


}
</style>